import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import "./login.css";

const specialNames = ["sahana", "sana", "anu", "anjan", "kumar", "anja","vuyya","boss lady","monster","baby"];

export default function Login({ onSuccess, onStartMusic }) {
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  const hasName = name.trim().length > 0;

  const openStory = () => {
    const cleanName = name.trim().toLowerCase();

    setError("");

    // Private keyword — complete story
    if (cleanName === "lovea&s") {
      onStartMusic?.();
      onSuccess("full");
      return;
    }

    // Regular invited guests — shorter story
    if (specialNames.includes(cleanName)) {
      onStartMusic?.();
      onSuccess("guest");
      return;
    }

    setError("That’s not one of our special names ♡");
  };

  return (
    <div className="loginContainer">
      <motion.div
        className="card"
        initial={{ opacity: 0, y: 50, scale: 0.96 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.9 }}
      >
        <h1>
          Anjan <span>❤</span> Sahana
        </h1>

        <p>Welcome to our little story...</p>

        <input
          type="text"
          placeholder="What do you call me..?"
          value={name}
          autoFocus
          onChange={(event) => {
            setName(event.target.value);
            setError("");
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter" && hasName) {
              openStory();
            }
          }}
        />

        <AnimatePresence>
          {hasName && (
            <motion.button
              key="open-story-button"
              type="button"
              className="openStoryButton"
              onClick={openStory}
              initial={{ opacity: 0, y: 14, scale: 0.96 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 10, scale: 0.96 }}
              transition={{
                duration: 0.35,
                type: "spring",
                stiffness: 190,
                damping: 16,
              }}
              whileHover={{ y: -2, scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              Open our little story <span>♡</span>
            </motion.button>
          )}
        </AnimatePresence>

        {error && (
          <motion.p
            className="error"
            initial={{ opacity: 0, y: 5 }}
            animate={{ opacity: 1, y: 0 }}
          >
            {error}
          </motion.p>
        )}
      </motion.div>
    </div>
  );
}